export const FETCH_ASSIGN_DATA_REQUEST = 'FETCH_ASSIGN_DATA_REQUEST';
export const FETCH_ASSIGN_DATA_SUCCESS = 'FETCH_ASSIGN_DATA_SUCCESS';
export const FETCH_ASSIGN_DATA_FAILURE = 'FETCH_ASSIGN_DATA_FAILURE';